// extracted by mini-css-extract-plugin
export default {"titulo":"ColumnaTorneosTipoInt_titulo__n1m0N","listado":"ColumnaTorneosTipoInt_listado__7HfIU","torneo":"ColumnaTorneosTipoInt_torneo__46eNb"};